import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { pipe, values, isEmpty, filter, length, lt, identity } from 'ramda';
import { Input, SubmitButton, Link, BottomText, Form, Description } from './resetPasswordForm.styles';
import messages from './resetPasswordForm.messages';
import { Modal } from '../modal';
import { REGISTRATION_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';
import { ignoreSpace } from '../../utils/input';

export class ResetPasswordForm extends PureComponent {
  static propTypes = {
    errors: PropTypes.object,
    handleSubmit: PropTypes.func,
    intl: PropTypes.object,
    isSubmitting: PropTypes.bool,
    hideModal: PropTypes.func.isRequired,
    values: PropTypes.object,
    onClose: PropTypes.func,
    onLoginClick: PropTypes.func,
    onSignUpClick: PropTypes.func,
    onSubmitClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    onClose: identity,
    onLoginClick: identity,
  };

  hasEmptyFields = () =>
    pipe(
      values,
      filter(isEmpty),
      length,
      lt(0)
    )(this.props.values);

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmitClick(this.props.values.email);
    this.props.handleSubmit(e);
  };

  handleClose = () => this.props.onClose();

  handleLoginClick = () => this.props.onLoginClick();

  handleSignUpClick = () => this.props.onSignUpClick();

  renderEmailField = ({ field, form }) => (
    <Input
      {...field}
      touched={form.touched[field.name]}
      error={form.errors[field.name]}
      type="email"
      onKeyDown={ignoreSpace}
      placeholder={this.props.intl.formatMessage(messages.emailPlaceholder)}
    />
  );

  render() {
    return (
      <Modal onClose={this.handleClose} title={this.props.intl.formatMessage(messages.title)}>
        <Description>
          <FormattedMessage {...messages.description} />
        </Description>
        <Form onSubmit={this.handleSubmit}>
          <Field name={FIELDS.email} render={this.renderEmailField} />

          <SubmitButton
            type="submit"
            disabled={this.hasEmptyFields() || this.props.isSubmitting}
            label={this.props.intl.formatMessage(messages.submitButton)}
          />
        </Form>
        <BottomText>
          <Link onClick={this.handleLoginClick}>
            <FormattedMessage {...messages.login} />
          </Link>
          <Link onClick={this.handleSignUpClick}>
            <FormattedMessage {...messages.signUp} />
          </Link>
        </BottomText>
      </Modal>
    );
  }
}
